module.exports = __webpack_public_path__ + "img/mobile_btn7.ffbf2d8a.png";